/**
 * Watermark du polling : le mail le plus récent (`sentDateTime`) parmi les copies **Inbox** du Record.
 *
 * `pollForNewMails` filtre l'Inbox via `sentDateTime gt latestDate`. La copie Sent d'un mail self-sent
 * partage le `sentDateTime` de sa copie Inbox ; l'inclure élèverait `latestDate` à ce niveau, et l'Inbox
 * ne serait jamais renvoyée → jamais analysée. D'où l'exclusion des copies non-Inbox. Fallback (tout sauf
 * `deletedItemsFolderId`) si `inboxFolderId` pas encore initialisé.
 */
export function selectLatestInboxMail<
    T extends {
        sentDateTime?: string | number | null;
        parentFolderId?: string;
    },
>(
    mails: T[],
    inboxFolderId: string | undefined,
    deletedItemsFolderId: string | undefined,
): T | null {
    const candidates = mails.filter((mail) => {
        if (mail.sentDateTime === undefined || mail.sentDateTime === null) {
            return false;
        }
        return inboxFolderId
            ? mail.parentFolderId === inboxFolderId
            : mail.parentFolderId !== deletedItemsFolderId;
    });

    let latest: T | null = null;
    for (const mail of candidates) {
        // sentDateTime ISO → comparaison lexicographique = chronologique. String() neutralise le
        // type IDateValue sans @ts-ignore (les null sont déjà écartés par le filtre ci-dessus).
        if (
            latest === null ||
            String(mail.sentDateTime) > String(latest.sentDateTime)
        ) {
            latest = mail;
        }
    }

    return latest;
}
